import { fetcher } from '@commenda/utils';

import {
  TRefreshContentParams,
  TRefreshContentResponse,
  REFRESH_FLAG_BY_CONTENT_TYPE
} from './types';


export async function refreshContent({
  contentType,
  token,
}: TRefreshContentParams): Promise<TRefreshContentResponse> {
  const res = await fetcher(
    'content-deployment/refresh',
    {
      method: 'POST',
      body: { [REFRESH_FLAG_BY_CONTENT_TYPE[contentType]]: true },
    },
    token
  );

  const data = await res.json();

  if (!res.ok) {
    const message = Array.isArray(data?.message)
      ? data.message.join(', ')
      : data?.message;
    throw new Error(
      typeof message === 'string' && message
        ? message
        : 'Failed to queue the content refresh.'
    );
  }

  return data;
}
